module.exports = require('./dist/SAlert');